<div id="dashboard-analytics" class="page-layout blank">
    <div class="content">

        <div class="left mr-lg-32">
            <div fxLayout="column" fxLayoutAlign="start"
                 fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">

                <!-- Widget 2 -->
                <div class="widget" fxFlex="100" fxFlex.gt-sm="33">

                    <div class="fuse-card auto-width mb-32" [ngClass.gt-sm]="'mb-0 mr-32'">

                        <div class="p-16 pb-0" fxLayout="row wrap" fxLayoutAlign="start end">
                            <div class="pr-16">
                                <div class="h3 secondary-text">{{'Date range'|translate}}</div>
                                <div class="font-size-40 font-weight-300 line-height-1 mt-8">
                                    <form [formGroup]="dateRange">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Start date</mat-label>
                                            <input matInput formControlName="start" [matDatepicker]="picker"
                                                   (dateChange)="reloadStats($event)">
                                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-datepicker #picker></mat-datepicker>
                                        </mat-form-field>
                                        <mat-form-field appearance="fill">
                                            <mat-label>End date</mat-label>
                                            <input matInput formControlName="end" [matDatepicker]="picker2"
                                                   (dateChange)="reloadStats($event)">
                                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                            <mat-datepicker #picker2></mat-datepicker>
                                        </mat-form-field>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- Widget 2 -->
                <div class="widget" fxFlex="100" fxFlex.gt-sm="25">

                    <div class="fuse-card auto-width mb-32" [ngClass.gt-sm]="'mb-0 mr-32'" style="padding-bottom: 20px;">

                        <div class="p-16 pb-0" fxLayout="row wrap" fxLayoutAlign="start end">

                            <div class="pr-16">
                                <div class="h3 secondary-text">
                                    {{'Total sold'|translate}}
                                    <app-info message="Quantity and value of {{product.name}} sold from the beginning."></app-info>
                                </div>

                                <h2>{{'Quantity'|translate}}</h2>
                                <div class="font-size-54 font-weight-300 line-height-1 mt-8" style="text-align: center;">
                                    {{totalSale.productsQuantity}} {{'pcs'|translate}}
                                </div>

                                <h2>{{'Value'|translate}}</h2>
                                <div class="font-size-54 font-weight-300 line-height-1 mt-8" style="text-align: center;">
                                    {{totalSale.grossValue}} PLN
                                </div>
                            </div>


                        </div>


                    </div>

                </div>

                <!-- Widget 2 -->
                <div class="widget" fxFlex="100" fxFlex.gt-sm="25" *ngFor="let year of totalSaleByYear.items">

                    <div class="fuse-card auto-width mb-32" [ngClass.gt-sm]="'mb-0 mr-32'" style="padding-bottom: 20px;">

                        <div class="p-16 pb-0" fxLayout="row wrap" fxLayoutAlign="start end">

                            <div class="pr-16">
                                <div class="h3 secondary-text">
                                    {{'Total sold in '|translate}} {{year.year}}
                                </div>
                                <h2>{{'Quantity'|translate}}</h2>
                                <div class="font-size-54 font-weight-300 line-height-1 mt-8" style="text-align: center;">
                                    {{year.productsQuantity}} {{'pcs'|translate}}
                                </div>
                                <h2>{{'Value'|translate}}</h2>
                                <div class="font-size-54 font-weight-300 line-height-1 mt-8" style="text-align: center;">
                                    {{year.grossValue}} {{'PLN'|translate}}
                                </div>
                            </div>


                        </div>


                    </div>

                </div>

            </div>




            <div fxLayout="column" fxLayoutAlign="start"
                 fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start" *ngIf="soldItems.items && soldItems.items.length>0">
                <div class="widget pt-0" fxFlex="100">

                    <div class="fuse-card content-card auto-width">

                        <table class="simple clickable">
                            <thead>
                            <tr>
                                <th>{{'Name'|translate}}</th>
                                <th class="text-left">{{'Date'|translate}}</th>
                                <th class="text-right">{{'Quantity'|translate}}</th>
                                <th class="text-right">{{'Value'|translate}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let row of soldItems.items">
                                <td>{{row.firstName}} {{row.lastName}} ({{row.username}})</td>
                                <td class="text-left">{{row.day}}-{{row.month}}-{{row.year}}</td>
                                <td class="text-right">{{row.productsQuantity}}</td>
                                <td class="text-right">{{row.productsGrossValue}} PLN</td>
                            </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>




        </div>
    </div>
</div>
